import "../style.css";
import { useState } from "react";
import { expertContext } from "../../../context/expertcontext";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { serverApi } from "../../../confing/confing";
const ExpertPanel = () => {
  const [toggel, setToggel] = useState(true);
  const [category, setCategory] = useState([]);
  const [tab, setTab] = useState(1);
  const [estate, setEstate] = useState({});
  const [attributes, setAttributes] = useState([]);
  const [attributes2, setAttributes2] = useState([]);
  const [attributes3, setAttributes3] = useState([]);
  const [areaInfo, setAreaInfo] = useState({});
  const [imgName, setImgName] = useState("");
  const [description, setDescription] = useState();
  const [totalPrice, setTotalPrice] = useState(0);
  const [page, setPage] = useState("درخواست ها");
  const [exInfo, setExInfo] = useState({});
  const [total1, setTotal1] = useState(0);
  const [total2, setTotal2] = useState(0);
  const [total3, setTotal3] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let token = localStorage.getItem("token");
        const { data } = await axios.get(`${serverApi}/expert/detail`, {
          headers: { authorization: `Bearer ${token}` },
        });
        console.log(data);
        setExInfo(data.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  return (
    <expertContext.Provider
      value={{
        toggel,
        setToggel,
        category,
        setCategory,
        tab,
        setTab,
        estate,
        setEstate,
        attributes,
        setAttributes,
        attributes2,
        setAttributes2,
        attributes3,
        setAttributes3,
        totalPrice,
        setTotalPrice,
        areaInfo,
        setAreaInfo,
        imgName,
        setImgName,
        description,
        setDescription,
        page,
        setPage,
        exInfo,
        setExInfo,
        total1,
        setTotal1,
        total2,
        setTotal2,
        total3,
        setTotal3,
      }}
    >
      <div>
        <Outlet />
      </div>
    </expertContext.Provider>
  );
};

export default ExpertPanel;
